import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{class:_vm.$style.printBtn,attrs:{"rounded":"","outlined":"","disabled":_vm.isLoading || _vm.disabled},on:{"click":_vm.handleClick}},[_c('span',{class:_vm.$style.text},[_vm._v("Print")]),_c('span',{class:_vm.$style.iconWrapper},[(_vm.isLoading)?_c(VIcon,{class:_vm.$style.icon + ' mdi-spin'},[_vm._v("mdi-loading")]):_c(VIcon,{class:_vm.$style.icon},[_vm._v("mdi-printer-outline")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }